import { normalizeDrawing } from "./drawingFormat";

// Device-local recovery copy of an open drawing, scoped to account, attempt
// and question. It is only ever offered back after comparing it with the
// server's state, and is never presented as saved.
//
// { editSessionId, baseRevision, sequence, ackedSequence, drawing,
//   cancelRequestId (set while a cancellation is not yet confirmed), updatedAt }

const PREFIX = "studyden.drawingRecovery.v1";

export const recoveryKey = (uid, attemptId, questionId) => `${PREFIX}.${uid}.${attemptId}.${questionId}`;

export const readRecovery = (uid, attemptId, questionId) => {
  try {
    const raw = window.localStorage.getItem(recoveryKey(uid, attemptId, questionId));
    if (!raw) return null;
    const value = JSON.parse(raw);
    if (typeof value?.editSessionId !== "string" || !Number.isSafeInteger(value.sequence) ||
        !Number.isSafeInteger(value.ackedSequence) || !Number.isSafeInteger(value.baseRevision)) return null;
    return {
      editSessionId: value.editSessionId,
      baseRevision: value.baseRevision,
      sequence: value.sequence,
      ackedSequence: value.ackedSequence,
      drawing: normalizeDrawing(value.drawing),
      cancelRequestId: typeof value.cancelRequestId === "string" ? value.cancelRequestId : null,
      updatedAt: typeof value.updatedAt === "string" ? value.updatedAt : null,
    };
  } catch (_error) {
    return null;
  }
};

// Returns false when storage is unavailable or full; the caller then tells
// the student that changes are only on this page.
export const writeRecovery = (uid, attemptId, questionId, value) => {
  try {
    window.localStorage.setItem(recoveryKey(uid, attemptId, questionId), JSON.stringify({
      ...value, updatedAt: new Date().toISOString(),
    }));
    return true;
  } catch (_error) {
    return false;
  }
};

export const clearRecovery = (uid, attemptId, questionId) => {
  try { window.localStorage.removeItem(recoveryKey(uid, attemptId, questionId)); } catch (_error) { /* storage unavailable */ }
};

export const hasUnsyncedChanges = (recovery) => Boolean(recovery) && recovery.sequence > recovery.ackedSequence;
